import { render, staticRenderFns } from "./analysisLimitSpace.vue?vue&type=template&id=161a71ed&scoped=true&"
import script from "./analysisLimitSpace.vue?vue&type=script&lang=ts&"
export * from "./analysisLimitSpace.vue?vue&type=script&lang=ts&"
import style0 from "./analysisLimitSpace.vue?vue&type=style&index=0&id=161a71ed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161a71ed",
  null
  
)

export default component.exports